import React, { useEffect, useState } from "react";
import { Button, Modal, Form } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router";
import {
	deleteSpinReward,
	fetchSpinReward,
	resetDeleteStatusSpinReward,
	updateSpinReward,
} from "../../../actions/spinTheWheelReward";

import "../Question.scss";
import { ReactSVG } from "react-svg";
import { Link, useHistory } from "react-router-dom";
import SpinRewardForm from "../../Forms/SpinTheWheelReward";
import { DateFormat, DateTimeFormat } from "../../../helpers/utils";
import moment from "moment";

const SpinRewardPage = () => {
	const { id } = useParams();
	const history = useHistory();
	const [form] = Form.useForm();
	const dispatch = useDispatch();
	const [isModalVisible, setIsModalVisible] = useState(false);
	const [spinRewardId, setSpinRewardId] = useState(null);
	const { status, spinReward } = useSelector((state) => state.fetchSpinReward);
	const { status: updateStatus } = useSelector(
		(state) => state.updateSpinReward,
	);
	const { spinRewardDeleted } = useSelector((state) => state.deleteSpinReward);
	const showModal = () => {
		setIsModalVisible(true);
	};

	const handleOk = () => {
		setIsModalVisible(false);
		form.resetFields();
		setSpinRewardId(null);
	};

	const handleCancel = () => {
		setIsModalVisible(false);
		form.resetFields();
		setSpinRewardId(null);
	};

	const handleEdit = () => {
		showModal();
		setSpinRewardId(spinReward.id);
		form.setFieldsValue({
			...spinReward,
			start_date: moment(spinReward.start_date).utcOffset("+08:00"),
			end_date: moment(spinReward.end_date).utcOffset("+08:00"),
		});
	};

	const handleDelete = () => {
		dispatch(deleteSpinReward(spinRewardId));
	};

	const handleSubmitForm = (values) => {
		const newValues = values;
		newValues.start_date = values.start_date
			? moment(values.start_date).format("DD/MM/YYYY")
			: null;
		newValues.end_date = values.end_date
			? moment(values.end_date).format("DD/MM/YYYY")
			: null;

		if (spinRewardId) {
			dispatch(updateSpinReward(spinRewardId, newValues));
		}
		handleOk();
	};

	useEffect(() => {
		if (id) {
			dispatch(fetchSpinReward(id));
		}
	}, [id]);

	useEffect(() => {
		if (updateStatus === "SUCCEEDED") dispatch(fetchSpinReward(id));
	}, [updateStatus]);

	useEffect(() => {
		if (spinRewardDeleted) {
			history.push("/spin-the-wheel/rewards");
			dispatch(resetDeleteStatusSpinReward());
		}
	}, [spinRewardDeleted]);

	useEffect(() => {
		if (spinReward && spinReward.id === Number(id)) {
			setSpinRewardId(spinReward.id);
		} else {
			setSpinRewardId();
		}
	}, [spinReward]);
	return (
		<div id="question-container">
			<div className="page-header">
				<h2 className="page-header-title">Reward Details</h2>
			</div>
			<div className="page-header-details-actions">
				<div className="left">
					<Link to="/spin-the-wheel/rewards">
						<Button type="link" className="btn btn-back">
							<ReactSVG src="/icons/arrow-left.svg" />
							Back
						</Button>
					</Link>
				</div>
				<div className="right">
					<Button
						type="primary"
						className="btn-primary"
						onClick={() => handleEdit()}
					>
						Edit
						<ReactSVG src="/icons/edit.svg" />
					</Button>
					<Button className="btn btn-danger" onClick={() => handleDelete()}>
						Delete
						<ReactSVG src="/icons/delete-all.svg" />
					</Button>
				</div>
			</div>
			{status === "SUCCEEDED" && (
				<div className="page-content">
					<div className="page-details-section">
						<div>
							<div className="box">
								<div className="box-header">
									<h2 className="box-title">Details</h2>
								</div>
								<div className="box-content">
									<div className="details-item">
										<label>Name</label>
										<div className="text" style={{ textTransform: "initial" }}>
											{spinReward.name}
										</div>
									</div>
									<div className="details-item">
										<label>Game</label>
										<div className="text" style={{ textTransform: "initial" }}>
											{spinReward.game.name}
										</div>
									</div>
									<div className="details-item">
										<label>Quantity</label>
										<div className="text" style={{ textTransform: "initial" }}>
											{spinReward.quantity}
										</div>
									</div>
									<div className="details-item">
										<label>Start Date</label>
										<div className="text">
											{DateFormat(spinReward.start_date)}
										</div>
									</div>
									<div className="details-item">
										<label>End Date</label>
										<div className="text">
											{DateFormat(spinReward.end_date)}
										</div>
									</div>
									<div className="details-item">
										<label>Updated At</label>
										<div className="text" style={{ textTransform: "initial" }}>
											{DateTimeFormat(spinReward.updated_at)}
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			)}
			<Modal
				className="spin-form-modal"
				visible={isModalVisible}
				onOk={handleOk}
				onCancel={handleCancel}
				footer={null}
			>
				<SpinRewardForm
					form={form}
					spinRewardId={spinRewardId}
					handleSubmitForm={handleSubmitForm}
					handleCancel={handleCancel}
				/>
			</Modal>
		</div>
	);
};

export default SpinRewardPage;
